import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { updatePrivatePin } from "../../../redux/ApiSlice/AccountPrivateSlice";

export default function ResetPassword() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");

    const handleSave = () => {
        if (currentPassword.length < 6 || newPassword.length < 6) {
            toast.error("Both PINs must be 6 digits");
            return;
        }
        if (isNaN(currentPassword) || isNaN(newPassword)) {
            toast.error("PINs must contain numbers only");
            return;
        }

        const data = {
            old_pin: currentPassword,
            new_pin: newPassword,
        };
        dispatch(updatePrivatePin(data))
            .then((result) => {
                if (result.payload?.error) {
                    toast.error(result.payload?.error);
                } else if (result.payload?.message) {
                    toast.success(result.payload?.message);
                    setTimeout(() => {
                        navigate("/private");
                    }, 1000);
                }
            })
            .catch(() => {
                toast.error("Failed to reset password");
            });
    };

    return (
        <>
            {/* Header */}
            <div className="sticky top-0 z-10">
                <div className="relative bg-[#BDE6FF] rounded-b-xl h-12 flex items-center justify-center">
                    <IoMdArrowBack
                        onClick={() => navigate("/private")}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[22px] text-black dark:text-black cursor-pointer"
                    />
                    <p className="font-bold text-[18px] text-black dark:text-black line-clamp-1">
                        Reset Private PIN
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <div className="h-full flex flex-col bg-white dark:bg-[#1E1D21]">
                <div className="flex flex-col items-center justify-center mt-8 px-4">
                    <p className="mb-8 text-center text-sm text-gray-600 dark:text-gray-400 max-w-sm">
                        Enter your current PIN and choose a new 6-digit PIN to secure your private content.
                    </p>

                    {/* Form */}
                    <div className="w-full max-w-md space-y-6">
                        {/* Current Password Field */}
                        <div>
                            <label
                                htmlFor="currentPassword"
                                className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                            >
                                Current PIN
                            </label>
                            <input
                                type="password"
                                maxLength={6}
                                value={currentPassword}
                                onChange={(e) =>
                                    e.target.value.length <= 6
                                        ? setCurrentPassword(e.target.value)
                                        : null
                                }
                                id="currentPassword"
                                placeholder="Enter current 6-digit PIN"
                                className="w-full h-12 px-4 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl outline-none focus:border-blue-500 dark:focus:border-blue-400 transition-colors text-gray-800 dark:text-white placeholder:text-gray-400 text-sm font-medium shadow-sm"
                            />
                        </div>

                        {/* New Password Field */}
                        <div>
                            <label
                                htmlFor="newPassword"
                                className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                            >
                                New PIN
                            </label>
                            <input
                                type="password"
                                maxLength={6}
                                value={newPassword}
                                onChange={(e) =>
                                    e.target.value.length <= 6 ? setNewPassword(e.target.value) : null
                                }
                                id="newPassword"
                                placeholder="Enter new 6-digit PIN"
                                className="w-full h-12 px-4 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl outline-none focus:border-blue-500 dark:focus:border-blue-400 transition-colors text-gray-800 dark:text-white placeholder:text-gray-400 text-sm font-medium shadow-sm"
                            />
                        </div>

                        {/* Save Button */}
                        <button
                            onClick={handleSave}
                            className="w-full h-12 rounded-xl bg-[#BDE6FF] hover:bg-[#A5D8F5] active:scale-95 flex items-center justify-center gap-2 text-black border border-black font-bold text-[16px] transition-all shadow-lg hover:shadow-xl mt-8"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            Save New PIN
                        </button>
                    </div>

                    {/* Info Box */}
                    <div className="mt-8 p-4 bg-orange-50 dark:bg-orange-900/20 rounded-xl border border-orange-200 dark:border-orange-800 max-w-md">
                        <div className="flex gap-3">
                            <svg className="w-5 h-5 text-orange-600 dark:text-orange-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                            <div>
                                <p className="text-sm text-gray-700 dark:text-gray-300 font-medium mb-1">
                                    Security Reminder
                                </p>
                                <p className="text-xs text-gray-600 dark:text-gray-400">
                                    Choose a PIN that you can remember but others cannot easily guess. Never share your PIN with anyone.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
